/* oxlint-disable func-names */

function vanillaSerialize(obj) {
    return angular.fromJson(angular.toJson(obj));
}

function asJson(obj) {
    if (obj.asJson) return obj.asJson();
    return vanillaSerialize(obj);
}

angular.module('Iguana').factory('Iguana.Serializers', [
    function () {
        return {
            instanceMixin: {
                asJson() {
                    const obj = {
                        ...this,
                    };

                    // Call asJson on each embedded object. This only because necessary for us
                    // when we started embedding a mixture of iguana objects and non-iguana objects
                    // in frame_list lessons, but I think it also would have been needed if we had
                    // ever wanted to override asJson on an embedded object
                    const embeds = {};
                    this.eachEmbedRelationship(relationship => {
                        const val = this[relationship.propName];
                        delete obj[relationship.propName];
                        if (!val) {
                            embeds[relationship.propName] = val;
                        } else if (relationship.type === 'many' && Array.isArray(val)) {
                            embeds[relationship.propName] = val.map(item => asJson(item));
                        } else if (relationship.type === 'many' && typeof val === 'object') {
                            const serializedObj = {};
                            Object.keys(val).forEach(key => {
                                serializedObj[key] = asJson(val[key]);
                            });
                            embeds[relationship.propName] = serializedObj;
                        } else if (relationship.type === 'many') {
                            throw new Error(
                                `Unexpected type for embedsMany relationship "${relationship.propName}": ${typeof val}`,
                            );
                        } else {
                            embeds[relationship.propName] = asJson(val);
                        }
                    });
                    const serialized = {
                        ...vanillaSerialize(obj),
                        ...embeds,
                    };

                    return serialized;
                },

                // Children can override this method to define the object and properties used for save calls.
                // This is useful when you have a lot of stuff on an Iguana object that isn't used in a controller.
                objectForSave() {
                    return this.asJson();
                },

                toJson() {
                    return angular.toJson(this);
                },
            },
        };
    },
]);
